import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, useLoginWithRedirect } from '@frontegg/react';
import AuthService from '../services/auth.service';

export default function Login() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const loginWithRedirect = useLoginWithRedirect();
  const authService = AuthService.getInstance();

  useEffect(() => {
    // Persist returnTo and token from query params so they survive the Frontegg redirect flow
    const params = new URLSearchParams(window.location.search);
    const returnToParam = params.get('returnTo');
    const returnTokenParam = params.get('returnToken');
    if (returnToParam) {
      localStorage.setItem('externalReturnTo', returnToParam);
      if (returnTokenParam) {
        localStorage.setItem('externalReturnToken', returnTokenParam);
      }
    }

    if (isAuthenticated) {
      // Check if login was initiated from another app (legacy or custom domain)
      const returnTo = localStorage.getItem('externalReturnTo');
      const returnToken = localStorage.getItem('externalReturnToken');
      if (returnTo) {
        localStorage.removeItem('externalReturnTo');
        localStorage.removeItem('externalReturnToken');
        try {
          const returnUrl = new URL(returnTo);
          const isLegacy = authService.legacyAppUrl && returnUrl.hostname === new URL(authService.legacyAppUrl).hostname;
          if (isLegacy) {
            // Known legacy domain — redirect directly
            window.location.href = returnTo;
            return;
          }
          if (returnToken) {
            // Custom domain — use backend to verify HMAC and redirect
            window.location.href = `/api/v1/auth/return?url=${encodeURIComponent(returnTo)}&token=${encodeURIComponent(returnToken)}`;
            return;
          }
        } catch {
          // Invalid URL, fall through to default
        }
      }
      const returnPath = localStorage.getItem('returnPath') || '/';
      localStorage.removeItem('returnPath');
      navigate(returnPath, { replace: true });
    } else if (authService.ssoLoginUrl) {
      // Custom domain with SSO configured — redirect directly to SSO provider
      window.location.href = authService.ssoLoginUrl;
    } else if (authService.useExternalLogin) {
      // Redirect to the legacy frontend for login since OAuth redirect URL is only configured there
      window.location.href = `${authService.authAppUrl}/login`;
    } else {
      // Redirect to Frontegg's login
      loginWithRedirect();
    }
  }, [isAuthenticated, navigate, loginWithRedirect]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-gray-500">Redirecting to login...</div>
    </div>
  );
}

